import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';

var _class, _descriptor;

/**
 * Modal-stack operations, extracted from the `applicationController.modalComponents`
 * push/splice the Classic mixins (component-edit, new-model) perform inline.
 *
 * Mixin-removal Phase 0: thin adapter over {@link AppStateService}. `open` pushes a
 * modal config onto the stack, `close` pops the current (top) modal, `closeCard`
 * delegates to the application controller's close-card task. Behavior is identical
 * to the inline push/splice the mixins do today; the service is DOM-free (the
 * `document.body.classList` toggling that surrounds `open` in new-model stays a
 * caller concern, per the runbook).
 *
 * @class ModalService
 * @extends Service
 */
let ModalService = (_class = class ModalService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "appState", _descriptor, this);
  }
  /**
   * Push a modal config onto the stack.
   * Mirrors new-model `_openCreationModal` / component-edit open paths.
   * @param {{title?: string, componentName?: string, item?: *}} config
   */
  open(config) {
    const current = Array.isArray(this.appState.modalComponents) ? this.appState.modalComponents : [];
    this.appState.modalComponents = [...current, config];
  }

  /**
   * Remove the current (top) modal from the stack.
   * Mirrors component-edit's splice of the current `modalComponent`.
   */
  close() {
    const current = [...(this.appState.modalComponents || [])];
    if (current.length > 0) {
      current.pop();
      this.appState.modalComponents = current;
    }
  }

  /**
   * Clear the whole modal stack.
   * Mirrors component-edit `set('modalComponents', [])`.
   */
  closeAll() {
    this.appState.modalComponents = [];
  }

  /**
   * Close an open card via the application controller's close-card task.
   * @param {*} item
   * @returns {TaskInstance}
   */
  closeCard(item) {
    return this.appState.closeCard(item);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appState", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ModalService as default };
//# sourceMappingURL=modal.js.map
